import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    requestsCounter = 0;

    constructor(private spinner: NgxSpinnerService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.headers.get('showSpinner') == 'false') {
            request = request.clone({
                headers: request.headers.delete('showSpinner'),
            });
            return next.handle(request);
        } else {
            request = request.clone({
                headers: request.headers.delete('showSpinner'),
            });
            this.requestsCounter++;
            if (this.requestsCounter > 0) {
                this.spinner.show();
            }
            return next.handle(request).pipe(
                finalize(() => {
                    this.requestsCounter--;
                    if (this.requestsCounter <= 0) {
                        this.requestsCounter = 0;
                        this.spinner.hide();
                    }
                })
            );
        }
    }
}
